// Size finder — step 1 (pick product) → step 2 (one measurement) → result.
// Product names, "Add to cart" URLs and the phone number come from the
// Customizer via wp_localize_script (window.wpsFit, see includes/assets.php);
// the sizing rules below are the only logic that lives here. US units only.

(function () {
  var cfg = window.wpsFit;
  var body = document.querySelector("[data-fit-body]");
  if (!cfg || !body) {
    return;
  }

  var steps = document.querySelectorAll("[data-fit-steps] .fit__step");
  var products = {};
  cfg.products.forEach(function (p) {
    products[p.id] = p;
  });

  // Each rule: what we ask, accepted range, how to read the input, and the
  // size buckets. calc() returns [size label, human range].
  var RULES = {
    insoles: {
      question: "Your US shoe size",
      hint: "Look at the tag inside your everyday shoe. Half sizes are welcome.",
      placeholder: "e.g. 9.5",
      min: 5,
      max: 15,
      read: number,
      error: "Enter a US shoe size between 5 and 15.",
      calc: function (v) {
        if (v < 7) return ["S", "US 5–6.5"];
        if (v < 9.5) return ["M", "US 7–9"];
        if (v < 11.5) return ["L", "US 9.5–11"];
        return ["XL", "US 11.5 and up"];
      },
    },
    brace: {
      question: "Your waist, in inches",
      hint: "Wrap a tape measure around your natural waist, about at belly-button height.",
      placeholder: "e.g. 36",
      min: 24,
      max: 60,
      read: number,
      error: "Enter your waist in inches, between 24 and 60.",
      calc: function (v) {
        if (v < 32) return ["S", 'under 32"'];
        if (v < 38) return ["M", '32–37"'];
        if (v < 44) return ["L", '38–43"'];
        return ["XL", '44" and up'];
      },
    },
    knee: {
      question: "Your knee, in inches",
      hint: "Measure around the leg about an inch above the kneecap.",
      placeholder: "e.g. 15",
      min: 9,
      max: 26,
      read: number,
      error: "Enter your knee measurement in inches, between 9 and 26.",
      calc: function (v) {
        if (v < 14) return ["S", 'under 14"'];
        if (v < 16) return ["M", '14–15.9"'];
        if (v < 17.5) return ["L", '16–17.4"'];
        return ["XL", '17.5" and up'];
      },
    },
    pillow: {
      question: "Your height",
      hint: "Feet and inches like 5'10\" — or just total inches like 70.",
      placeholder: "e.g. 5'10\"",
      min: 52,
      max: 84,
      read: height,
      error: "Enter your height like 5'10\" or as inches, between 4'4\" and 7'0\".",
      calc: function (v) {
        if (v < 63) return ["Low loft", "under 5'3\""];
        if (v <= 71) return ["Medium loft", "5'3\"–5'11\""];
        return ["High loft", "6'0\" and up"];
      },
    },
  };

  function number(raw) {
    var v = parseFloat(String(raw).replace(",", "."));
    return isNaN(v) ? null : v;
  }

  // "5'10", 5'10", 5 ft 10, 5-10 → inches; a plain number is already inches.
  function height(raw) {
    var s = String(raw).trim();
    var m = s.match(/^(\d)\s*(?:'|ft|feet|-|\s)\s*(\d{1,2})?\s*(?:"|in|inches)?$/i);
    if (m && s.indexOf(".") === -1) {
      return parseInt(m[1], 10) * 12 + (m[2] ? parseInt(m[2], 10) : 0);
    }
    return number(s);
  }

  function esc(str) {
    var d = document.createElement("div");
    d.textContent = str;
    return d.innerHTML;
  }

  function setStep(n) {
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.toggle("is-on", i <= n);
    }
  }

  function render(html, focusSel) {
    body.innerHTML = html;
    var target = body.querySelector(focusSel || ".fit__q");
    if (target) {
      target.focus({ preventScroll: true });
    }
  }

  function stepOne() {
    setStep(0);
    var opts = cfg.products
      .map(function (p) {
        return '<button type="button" class="fit__option" data-fit-pick="' + esc(p.id) + '">' + esc(p.name) + "</button>";
      })
      .join("");
    render('<h3 class="fit__q" tabindex="-1">Step 1 — What are we sizing?</h3><div class="fit__options">' + opts + "</div>");
  }

  function stepTwo(id) {
    var p = products[id];
    var rule = RULES[id];
    if (!p || !rule) {
      return stepOne();
    }
    setStep(1);
    render(
      '<h3 class="fit__q" tabindex="-1">Step 2 — ' + esc(rule.question) + "</h3>" +
        '<p class="fit__hint" id="fitHint">' + esc(rule.hint) + "</p>" +
        '<form class="fit__form" novalidate>' +
        '<label class="screen-reader-text" for="fitValue">' + esc(rule.question) + "</label>" +
        '<input class="fit__input" id="fitValue" type="text" inputmode="text" autocomplete="off" aria-describedby="fitHint" placeholder="' + esc(rule.placeholder) + '">' +
        '<button type="submit" class="btn btn--primary btn--lg">See my size</button>' +
        '<button type="button" class="btn btn--ghost-inverse btn--lg" data-fit-back>Back</button>' +
        "</form>" +
        '<p class="fit__error" data-fit-error role="alert"></p>'
    );

    var form = body.querySelector(".fit__form");
    var input = body.querySelector("#fitValue");
    var error = body.querySelector("[data-fit-error]");
    input.focus({ preventScroll: true });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = rule.read(input.value);
      if (v === null || v < rule.min || v > rule.max) {
        error.textContent = rule.error;
        input.setAttribute("aria-invalid", "true");
        input.focus();
        return;
      }
      result(id, rule.calc(v));
    });
  }

  function cartHref(p, size) {
    if (!p.url) {
      return "#products";
    }
    return p.url + (p.url.indexOf("?") === -1 ? "?" : "&") + "size=" + encodeURIComponent(size);
  }

  function result(id, r) {
    var p = products[id];
    setStep(1);
    render(
      '<p class="fit__eyebrow">Your easy size</p>' +
        '<h3 class="fit__q fit__result" tabindex="-1">' + esc(r[0]) + "</h3>" +
        '<p class="fit__hint">That’s our pick for ' + esc(r[1]) + " — " + esc(p.name) + ". Not sure? Call us and a human will double-check it with you.</p>" +
        '<div class="fit__actions">' +
        '<a class="btn btn--primary btn--lg" href="' + esc(cartHref(p, r[0])) + '">Add to cart — ' + esc(r[0]) + "</a>" +
        '<a class="btn btn--ghost-inverse btn--lg" href="' + esc(cfg.phoneHref) + '">Call to confirm' + (cfg.phone ? " · " + esc(cfg.phone) : "") + "</a>" +
        '<button type="button" class="fit__again" data-fit-restart>Size something else</button>' +
        "</div>",
      ".fit__result"
    );
  }

  body.addEventListener("click", function (e) {
    var pick = e.target.closest("[data-fit-pick]");
    if (pick) {
      return stepTwo(pick.getAttribute("data-fit-pick"));
    }
    if (e.target.closest("[data-fit-back]") || e.target.closest("[data-fit-restart]")) {
      stepOne();
    }
  });

  // Product cards: jump into step 2 of that product.
  document.querySelectorAll("[data-fit-goto]").forEach(function (a) {
    a.addEventListener("click", function () {
      stepTwo(a.getAttribute("data-fit-goto"));
    });
  });
})();
